import React from 'react';
import { useIntl } from 'react-intl-next';
import { tableMessages as messages } from '@atlaskit/editor-common/messages';
import { Box, Inline, xcss } from '@atlaskit/primitives';
var tableFullWidthLabelStyles = xcss({
  minWidth: '120px',
  height: "var(--ds-space-300, 24px)",
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});
export var FullWidthDisplay = function FullWidthDisplay() {
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: tableFullWidthLabelStyles
  }, /*#__PURE__*/React.createElement(Inline, null, formatMessage(messages.fullWidthLabel)));
};